/**
 * Canonical funnel-stage order + human labels for the dashboard (epic-6).
 *
 * Mirrors the backend FUNNEL_EVENT_TYPES (schemas/funnel.py) so the dashboard
 * always renders the same scan -> delivery stages in the same order, even before
 * prizes has emitted a given event (count normalised to 0 server-side).
 */

export interface FunnelStageDef {
  key: string;
  label: string;
}

/** The scan -> delivery journey, in render order. */
export const FUNNEL_STAGES: readonly FunnelStageDef[] = [
  { key: 'qr_scan', label: 'QR scan' },
  { key: 'link_click', label: 'Link click' },
  { key: 'page_visit', label: 'Page visit' },
  { key: 'registration', label: 'Registration' },
  { key: 'skill_started', label: 'Skill started' },
  { key: 'skill_completed', label: 'Skill completed' },
  { key: 'share', label: 'Share' },
  { key: 'referral', label: 'Referral' },
  { key: 'lead_opt_in', label: 'Lead opt-in' },
  { key: 'winner_verified', label: 'Winner verified' },
  { key: 'prize_delivered', label: 'Prize delivered' },
] as const;

/** Format a 0..1 rate as a percentage string, or an em-dash when unknown. */
export function formatRate(rate: number | null | undefined): string {
  if (rate === null || rate === undefined || Number.isNaN(rate)) return '—';
  return `${(rate * 100).toFixed(1)}%`;
}

/** Compact, locale-aware integer formatting (1,234). */
export function formatCount(value: number): string {
  return new Intl.NumberFormat().format(value);
}

/** A friendly "as of" line from an ISO timestamp, or null when never pulled. */
export function formatAsOf(asOf: string | null | undefined): string | null {
  if (!asOf) return null;
  const d = new Date(asOf);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleString();
}
